import { render, staticRenderFns } from "./AlternateContactUpdateModal.vue?vue&type=template&id=45abdb7c&"
import script from "./AlternateContactUpdateModal.vue?vue&type=script&lang=js&"
export * from "./AlternateContactUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports